
export const MessageAlert = 'Thanks for submitting an offer on this home, it is currently under review. We will reach out via email to discuss next steps.';

export const AgentRepresentationProgramTierMax = 'Max';
